import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReportService } from '../../services/report.service';
import { ReportDownloadService } from '../../services/report-download.service';
import { ReportResponse } from '../../models/report-response.model';
import { RoutingService } from '../../../routing/services/routing.service';
import { Subscription } from 'rxjs/Subscription';
import * as FileSaver from 'file-saver';
import { EventsService } from '../../../events/services/events.service';

@Component({
    selector: 'app-report-list',
    templateUrl: './report-list.component.html',
    styleUrls: ['../../scss/report-list-common.scss']
})

export class ReportListComponent implements OnInit, OnDestroy {
    projects: ReportResponse[];
    projectCount: number;
    deletedReports: ReportResponse[];
    selectedReports: ReportResponse[] = new Array<ReportResponse>();
    selectedProjectCount: number;
    reportListSubscription: Subscription;
    editingReportName = false;
    reportBeingEdited: ReportResponse;
    completingAction = false;
    actionText: string;

    constructor(private reportService: ReportService, private routingService: RoutingService,
        private reportDownloadService: ReportDownloadService,
        private eventsService: EventsService) {
       
        this.reportListSubscription = this.reportService.onReportSummaryUpdate.subscribe(
            (response) => {
                this.projects = response.filter((project) => !project.report.isDeleted);
                this.projectCount = this.projects.length;
                this.deletedReports = response.filter((project) => project.report.isDeleted);
                this.selectedReports = this.projects.filter((project) => project.report.isSelected);
                this.selectedProjectCount = this.selectedReports.length;
                this.setSpinner(true);
            },
            (error) => console.log(error)
        );
    }

    ngOnInit() {
        this.reportService.getAllReportSummarys();
    }

    ngOnDestroy() {
        this.selectedReports.filter(p => p.report.isSelected).forEach(p => p.report.isSelected = false);
        this.reportListSubscription.unsubscribe();
    }

    toggleReportNameEdit(report) {
        if (!this.editingReportName) {
            this.editingReportName = true;
            this.reportBeingEdited = report;
            report.report.isRenaming = true;
        }else {
            this.reportService.renameReport(report).subscribe(
                (response) => {
                    this.editingReportName = false;
                    this.reportBeingEdited = undefined;
                },
                (error) => console.log(error)
            );
            report.report.isRenaming = false;
        }
    }

    select(event: any, report: ReportResponse) {
        const selected = event.target.checked;
        report.report.isSelected = selected;

        if (report.report.isSelected) {
            this.selectedReports.push(report);
        }else {
            this.selectedReports.splice(this.selectedReports.indexOf(report), 1);
        }

        this.selectedProjectCount = this.selectedReports.length;
    }

    get itemsSelected() {
        return this.projects.some( (i) => i.report.isSelected);
    }

    archiveReports(report: ReportResponse = null) {
        this.setSpinner(false, 'Archiving Reports');
        if (this.selectedProjectCount === 0 && report === null) {
            this.setSpinner(true);
            return;
        }
        const reports = new Array<ReportResponse>();
        if (report !== null) {
            reports.push(report);
        }

        if (this.selectedProjectCount > 0) {
            this.selectedReports.forEach( (r) => reports.push(r) );
        }

        this.eventsService.recordReportArchivedEvent();

        this.reportService.archiveReports(Array.from(new Set(reports))).subscribe(
            (response) => {
                this.reportService.getAllReportSummarys();
             },
            (error) => {
                console.log(error);
                this.setSpinner(true);
            }
        );
    }

    downloadReports() {
        this.setSpinner(false, 'Downloading Reports');
        for (let i = 0; i < this.selectedReports.length; i++) {
            const report = this.selectedReports[i];

            if (report === undefined) {
                console.error('Cannot find original report, unable to download.');
                this.setSpinner(true);
                return;
            }

            this.eventsService.recordReportDownloadedEvent(report.reportSummary.reportTypeName);

            this.reportDownloadService.downloadFile(report.report.id).subscribe(
            (response) => {
                const fileName = this.reportDownloadService.getFilenameFromResponse(response);
                FileSaver.saveAs(response.body, fileName);
                this.reportService.getAllReportSummarys();
            },
            (error) => {
                console.log(error);
                this.setSpinner(true);
            }
        );
        }
    }

    downloadPdf() {
        this.setSpinner(false, 'Downloading Report');
        for (let i = 0; i < this.selectedReports.length; i++) {
            const report = this.selectedReports[i];
            const originalReport = this.projects[this.projects.indexOf(report)];

            if (originalReport === undefined) {
                console.error('Cannot find original report, unable to download.');
                this.setSpinner(true);
                return;
            }

            this.reportDownloadService.downloadFile(report.report.id).map(r => r).subscribe(
                (response) => {
                    const fileExtension = 'pdf';
                    const reportName = response.filename + '.' + fileExtension;
                    const blob = new Blob([response], {type: 'application/pdf'});
                    FileSaver.saveAs(blob, reportName);
                    this.reportService.getAllReportSummarys();
                 },
                (error) => {
                    console.log(error);
                    this.setSpinner(true);
                }
            );
        }
    }

    viewSummary(id: number) {
        this.routingService.routeToReportSummary(id);
    }

    setSpinner(completed: boolean, text: string = '') {
        this.completingAction = !completed;
        this.actionText = text;
    }
}



// WEBPACK FOOTER //
// ./src/app/report/components/report-list/report-list.component.ts